import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import ChatList from './ChatList';
import ChatMain from './ChatMain';

// 画面遷移作成
const MainStack = createNativeStackNavigator();

/** ================================
*  チャット画面ナビゲーション
*  ================================*/
export default function ChatNavigator() {
  return (
    <MainStack.Navigator screenOptions={{ headerShown: false }}>
      <MainStack.Screen name="ChatList" component={ChatList} options={{ title: 'チャット一覧' }} />
      <MainStack.Screen name="ChatMain" component={ChatMain} options={{ title: 'チャット' }} />
    </MainStack.Navigator>
  );
}
